module.exports = __webpack_public_path__ + "components/easter-infographic/static/background-694f7ace5dbdbd3e3b26dd11b1bd9019.jpg";